/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `DxpTenantStatusCode*`'s.
 */
export type DxpTenantStatusCode = DxpTenantStatusCodeDeploying | DxpTenantStatusCodeLive | DxpTenantStatusCodeError;

/**
 * The tenant is currently deploying.
 * @export
 */
export type DxpTenantStatusCodeDeploying = typeof DXP_TENANT_STATUS_CODE_DEPLOYING;

/**
 * The tenant is live and ready to use.
 * @export
 */
export type DxpTenantStatusCodeLive = typeof DXP_TENANT_STATUS_CODE_LIVE;

/**
 * * The tenant is in error state and not available to use.
 * @export
 */
export type DxpTenantStatusCodeError = typeof DXP_TENANT_STATUS_CODE_ERROR;

/**
 * The status code to describe that tenant is deploying.
 * @export
 */
export const DXP_TENANT_STATUS_CODE_DEPLOYING = `deploying`;

/**
 * The status code to describe that tenant is live.
 * @export
 */
export const DXP_TENANT_STATUS_CODE_LIVE = `live`;

/**
 * The status code to describe that tenant is in error state and not available to use.
 * @export
 */
export const DXP_TENANT_STATUS_CODE_ERROR = `error`;
